import { lazy } from "react";

import { FeatherDemoReturn } from "@/components/FeatherDemoReturn";
import { FeatherFlowSwitcher } from "@/components/FeatherFlowSwitcher";

/**
 * The partner review pages, loaded on demand, and the review walkthrough's
 * preview nav. Demo-only: shipped code reads these only behind
 * `DEMO_SURFACES_IN_BUILD`, a literal the bundler folds, so a production build
 * drops this module, the pages and their chunks, and its source map carries
 * none of them. Keep every reference to it behind that flag.
 */
export const REVIEW_PAGES = {
  articleJobPosting: /*#__PURE__*/ lazy(() =>
    import("./pages/ArticleJobExperience").then((m) => ({ default: m.ArticleJobPosting })),
  ),
  articleApplication: /*#__PURE__*/ lazy(() =>
    import("./pages/ArticleJobExperience").then((m) => ({ default: m.ArticleApplication })),
  ),
  featherAtsIntegration: /*#__PURE__*/ lazy(() => import("./pages/FeatherATSIntegration")),
  featherApplicantThankYou: /*#__PURE__*/ lazy(() => import("./pages/FeatherApplicantThankYou")),
  featherShowcase: /*#__PURE__*/ lazy(() => import("./pages/FeatherShowcase")),
  featherDemoSetup: /*#__PURE__*/ lazy(() => import("./pages/FeatherDemoSetup")),
  featherPreviewNav: FeatherFlowSwitcher,
  featherDemoReturn: FeatherDemoReturn,
};
